export enum FORM_NAME {
  CREATE_PROMPT = 'CREATE_PROMPT',
  UPDATE_PROMPT = 'UPDATE_PROMPT',
}
